module.exports = __webpack_public_path__ + "static/media/DOTUSD.db32baa8.svg";